export enum ModuleTokens {
  Name = 'ticketCopyList'
}
